import { MantineTheme } from "@mantine/core";
import { DataMapMarkerProps, latLng, ValuesRecord } from "@mcurros2/microm";


export function HistorialCheckinVerUbicacionTiendaViewMarkerRenderer(record: ValuesRecord, position: latLng, theme: MantineTheme): DataMapMarkerProps | null {

    const tienda = record[3] as string;

    const color = theme.colors.green[6];

    const markerProps: DataMapMarkerProps = {
        position: position,
        title: `${tienda}`,
        assignColorByValue: undefined,
        fillColor: color,
    }

    return markerProps;
}